import React, { useState, useEffect } from 'react';

function RealisticBusinessDirectory({ user, onBack }) {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const categories = [
    { id: 'all', name: 'All', icon: '🏪' },
    { id: 'education', name: 'Education', icon: '📚' },
    { id: 'food', name: 'Food & Catering', icon: '🍽️' },
    { id: 'tailoring', name: 'Tailoring', icon: '✂️' },
    { id: 'beauty', name: 'Beauty & Salon', icon: '💄' },
    { id: 'repair', name: 'Repair Services', icon: '🔧' },
    { id: 'healthcare', name: 'Healthcare', icon: '🏥' }
  ];

  useEffect(() => {
    const demoBusinesses = [
      {
        id: '1',
        name: 'Priya\'s Home Tutoring',
        owner: 'Priya Sharma',
        category: 'education',
        description: 'Experienced teacher offering personalized home tutoring for Math, Science, and English.',
        image: 'https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=300&h=200&fit=crop',
        rating: 4.8,
        reviews: 24,
        price: '₹500-800/month',
        phone: '1234567890',
        whatsapp: '1234567890',
        address: 'Sector 14, Udaipur',
        verified: true,
        studentInfo: 'Parent of Arjun - Class 6A'
      },
      {
        id: '2',
        name: 'Meera\'s Tailoring Studio',
        owner: 'Meera Patel',
        category: 'tailoring',
        description: 'Professional tailoring services for all occasions. Traditional and modern designs.',
        image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop',
        rating: 4.6,
        reviews: 18,
        price: '₹200-1500/piece',
        phone: '1234567891',
        whatsapp: '1234567891',
        address: 'Hiran Magri, Udaipur',
        verified: true,
        studentInfo: 'Parent of Kavya - Class 4B'
      },
      {
        id: '3',
        name: 'Rajesh Tiffin Service',
        owner: 'Rajesh Kumar',
        category: 'food',
        description: 'Healthy homemade tiffin service with North and South Indian dishes.',
        image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=300&h=200&fit=crop',
        rating: 4.7,
        reviews: 32,
        price: '₹80-150/meal',
        phone: '1234567892',
        whatsapp: '1234567892',
        address: 'Fateh Nagar, Udaipur',
        verified: true,
        studentInfo: 'Parent of Rohan - Class 7A'
      }
    ];
    
    setTimeout(() => {
      setBusinesses(demoBusinesses);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredBusinesses = businesses.filter(business => {
    const matchesCategory = selectedCategory === 'all' || business.category === selectedCategory;
    const matchesSearch = business.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         business.owner.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleCall = (phone) => {
    window.open(`tel:${phone}`);
  };

  const handleWhatsApp = (phone) => {
    window.open(`https://wa.me/${phone.replace(/[^0-9]/g, '')}`);
  };

  if (selectedBusiness) {
    return (
      <BusinessDetail 
        business={selectedBusiness}
        onBack={() => setSelectedBusiness(null)}
        onCall={handleCall}
        onWhatsApp={handleWhatsApp}
      />
    );
  }

  return (
    <div className="business-directory">
      {/* Header */}
      <div className="header">
        <div className="header-top">
          <button className="back-btn" onClick={onBack}>←</button>
          <div className="header-content">
            <h1>Business Directory</h1>
            <p>Trusted parent-owned businesses</p>
          </div>
        </div>

        {/* Search */}
        <div className="search-container">
          <div className="search-input-wrapper">
            <input
              type="text"
              className="search-input"
              placeholder="Search businesses or owners..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">🔍</div>
          </div>
        </div>

        {/* Categories */}
        <div className="categories">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.id)}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-name">{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="content">
        <div className="results-info">
          <span className="results-count">{filteredBusinesses.length} businesses found</span>
          <div className="trust-badges">
            <span className="trust-badge">✓ Parent Verified</span>
            <span className="trust-badge">📞 Direct Contact</span>
          </div>
        </div>

        {loading ? (
          <div className="loading">
            <div className="loading-spinner"></div>
            <p>Loading businesses...</p>
          </div>
        ) : (
          <div className="business-list">
            {filteredBusinesses.map(business => (
              <BusinessCard
                key={business.id}
                business={business}
                onClick={() => setSelectedBusiness(business)}
                onCall={handleCall}
                onWhatsApp={handleWhatsApp}
              />
            ))}
          </div>
        )}

        {!loading && filteredBusinesses.length === 0 && (
          <div className="no-results">
            <div className="no-results-icon">🔍</div>
            <h3>No businesses found</h3>
            <p>Try adjusting your search or category</p>
          </div>
        )}
      </div>

      <style jsx>{`
        .business-directory {
          min-height: 100vh;
          background: linear-gradient(135deg, #E3F2FD 0%, #FFFFFF 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .header {
          background: white;
          padding: 20px;
          box-shadow: 0 2px 12px rgba(30, 90, 168, 0.08);
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-top {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }

        .back-btn {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #F1F5F9;
          border: 1px solid #E2E8F0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          cursor: pointer;
          font-size: 18px;
          color: #475569;
          transition: all 0.2s ease;
        }

        .back-btn:hover {
          background: #E2E8F0;
          transform: translateX(-2px);
        }

        .header-content h1 {
          font-size: 24px;
          font-weight: 600;
          color: #1E5AA8;
          margin: 0 0 4px 0;
        }

        .header-content p {
          font-size: 14px;
          color: #64748B;
          margin: 0;
        }

        .search-container {
          margin-bottom: 20px;
        }

        .search-input-wrapper {
          position: relative;
        }

        .search-input {
          width: 100%;
          padding: 12px 16px 12px 48px;
          border: 1px solid #E2E8F0;
          border-radius: 12px;
          font-size: 15px;
          background: #FAFBFC;
          transition: all 0.2s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #1E5AA8;
          background: white;
          box-shadow: 0 0 0 3px rgba(30, 90, 168, 0.1);
        }

        .search-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          color: #94A3B8;
        }

        .categories {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          padding-bottom: 8px;
        }

        .category-btn {
          background: #F8FAFC;
          border: 1px solid #E2E8F0;
          padding: 8px 16px;
          border-radius: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          white-space: nowrap;
          transition: all 0.2s ease;
          font-size: 14px;
          color: #475569;
        }

        .category-btn:hover {
          background: #F1F5F9;
        }

        .category-btn.active {
          background: linear-gradient(135deg, #F57C00 0%, #FF9800 100%);
          color: white;
          border-color: #F57C00;
        }

        .category-icon {
          font-size: 16px;
        }

        .content {
          padding: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .results-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          padding: 16px 20px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(30, 90, 168, 0.06);
        }

        .results-count {
          font-size: 16px;
          font-weight: 500;
          color: #1E5AA8;
        }

        .trust-badges {
          display: flex;
          gap: 12px;
        }

        .trust-badge {
          font-size: 12px;
          color: #10B981;
          font-weight: 500;
        }

        .business-list {
          display: grid;
          gap: 16px;
        }

        .loading {
          text-align: center;
          padding: 60px 20px;
          color: #64748B;
        }

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #E2E8F0;
          border-top: 3px solid #1E5AA8;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .no-results {
          text-align: center;
          padding: 60px 20px;
          color: #64748B;
        }

        .no-results-icon {
          font-size: 64px;
          margin-bottom: 16px;
        }

        .no-results h3 {
          color: #334155;
          margin-bottom: 8px;
        }

        @media (max-width: 768px) {
          .results-info {
            flex-direction: column;
            gap: 12px;
            text-align: center;
          }

          .trust-badges {
            justify-content: center;
          }

          .categories {
            justify-content: flex-start;
          }
        }
      `}</style>
    </div>
  );
}

function BusinessCard({ business, onClick, onCall, onWhatsApp }) {
  return (
    <div className="business-card" onClick={onClick}>
      <div className="business-image">
        <img 
          src={business.image} 
          alt={business.name}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300x200/E5E7EB/9CA3AF?text=Business';
          }}
        />
        {business.verified && (
          <div className="verified-badge">
            <span>✓</span>
          </div>
        )}
        <div className="rating-badge">
          <span>⭐</span>
          <span>{business.rating}</span>
        </div>
      </div>

      <div className="business-info">
        <div className="business-header">
          <h3 className="business-name">{business.name}</h3>
          <div className="business-price">{business.price}</div>
        </div>

        <div className="owner-info">
          <span className="owner-name">by {business.owner}</span>
          <span className="student-info">{business.studentInfo}</span>
        </div>

        <p className="business-description">{business.description}</p>

        <div className="business-meta">
          <div className="location">
            <span className="location-icon">📍</span>
            <span>{business.address}</span>
          </div>
          <div className="reviews">
            <span>{business.reviews} reviews</span>
          </div>
        </div>

        <div className="business-actions" onClick={(e) => e.stopPropagation()}>
          <button 
            className="action-btn whatsapp-btn"
            onClick={() => onWhatsApp(business.whatsapp)}
          >
            <span>💬</span>
            WhatsApp
          </button>
          <button 
            className="action-btn call-btn"
            onClick={() => onCall(business.phone)}
          >
            <span>📞</span>
            Call
          </button>
        </div>
      </div>

      <style jsx>{`
        .business-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(30, 90, 168, 0.08);
          border: 1px solid rgba(30, 90, 168, 0.05);
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          gap: 16px;
          padding: 16px;
        }

        .business-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(30, 90, 168, 0.12);
        }

        .business-image {
          position: relative;
          width: 120px;
          height: 90px;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0;
        }

        .business-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .verified-badge {
          position: absolute;
          top: 6px;
          right: 6px;
          background: #10B981;
          color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: 600;
        }

        .rating-badge {
          position: absolute;
          bottom: 6px;
          left: 6px;
          background: rgba(0,0,0,0.8);
          color: white;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .business-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .business-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .business-name {
          font-size: 18px;
          font-weight: 600;
          color: #1E5AA8;
          margin: 0;
          line-height: 1.3;
        }

        .business-price {
          font-size: 14px;
          font-weight: 600;
          color: #10B981;
          background: #ECFDF5;
          padding: 4px 8px;
          border-radius: 6px;
        }

        .owner-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .owner-name {
          font-size: 14px;
          font-weight: 500;
          color: #475569;
        }

        .student-info {
          font-size: 12px;
          color: #64748B;
        }

        .business-description {
          font-size: 14px;
          color: #64748B;
          line-height: 1.4;
          margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .business-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #64748B;
        }

        .location {
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .business-actions {
          display: flex;
          gap: 8px;
          margin-top: auto;
        }

        .action-btn {
          flex: 1;
          padding: 8px 12px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.2s ease;
        }

        .whatsapp-btn {
          background: #25D366;
          color: white;
        }

        .whatsapp-btn:hover {
          background: #22C55E;
        }

        .call-btn {
          background: #1E5AA8;
          color: white;
        }

        .call-btn:hover {
          background: #1E40AF;
        }

        @media (max-width: 768px) {
          .business-card {
            flex-direction: column;
            gap: 12px;
          }

          .business-image {
            width: 100%;
            height: 160px;
          }

          .business-header {
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;
          }

          .business-meta {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }
        }
      `}</style>
    </div>
  );
}

function BusinessDetail({ business, onBack, onCall, onWhatsApp }) {
  return (
    <div className="business-detail">
      <div className="detail-header">
        <button className="back-btn" onClick={onBack}>←</button>
        <h1>Business Details</h1>
      </div>

      <div className="detail-content">
        <div className="business-hero">
          <img 
            src={business.image} 
            alt={business.name}
            className="hero-image"
          />
          <div className="hero-info">
            <div className="hero-header">
              <h2>{business.name}</h2>
              {business.verified && <div className="verified-badge">✓ Verified</div>}
            </div>
            <div className="rating-info">
              <span className="rating">⭐ {business.rating}</span>
              <span className="reviews">({business.reviews} reviews)</span>
            </div>
            <div className="owner-info">
              <span className="owner">by {business.owner}</span>
              <span className="student">{business.studentInfo}</span>
            </div>
          </div>
        </div>

        <div className="detail-sections">
          <div className="section">
            <h3>About</h3>
            <p>{business.description}</p>
          </div>

          <div className="section">
            <h3>Contact Information</h3>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>{business.phone}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">💬</span>
                <span>{business.whatsapp}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>{business.address}</span>
              </div>
            </div>
          </div>

          <div className="section">
            <h3>Pricing</h3>
            <div className="pricing-info">
              <span className="price">{business.price}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="action-buttons">
        <button 
          className="action-btn whatsapp-btn"
          onClick={() => onWhatsApp(business.whatsapp)}
        >
          <span>💬</span>
          WhatsApp Now
        </button>
        <button 
          className="action-btn call-btn"
          onClick={() => onCall(business.phone)}
        >
          <span>📞</span>
          Call Now
        </button>
      </div>

      <style jsx>{`
        .business-detail {
          min-height: 100vh;
          background: linear-gradient(135deg, #E3F2FD 0%, #FFFFFF 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .detail-header {
          background: white;
          padding: 20px;
          display: flex;
          align-items: center;
          box-shadow: 0 2px 12px rgba(30, 90, 168, 0.08);
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .back-btn {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #F1F5F9;
          border: 1px solid #E2E8F0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          cursor: pointer;
          font-size: 18px;
          color: #475569;
          transition: all 0.2s ease;
        }

        .back-btn:hover {
          background: #E2E8F0;
        }

        .detail-header h1 {
          font-size: 20px;
          font-weight: 600;
          color: #1E5AA8;
          margin: 0;
        }

        .detail-content {
          padding: 20px;
          max-width: 800px;
          margin: 0 auto;
        }

        .business-hero {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          margin-bottom: 20px;
          box-shadow: 0 4px 16px rgba(30, 90, 168, 0.08);
        }

        .hero-image {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        .hero-info {
          padding: 20px;
        }

        .hero-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .hero-header h2 {
          font-size: 24px;
          font-weight: 600;
          color: #1E5AA8;
          margin: 0;
        }

        .verified-badge {
          background: #10B981;
          color: white;
          padding: 6px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
        }

        .rating-info {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 12px;
        }

        .rating {
          font-size: 16px;
          font-weight: 600;
          color: #F59E0B;
        }

        .reviews {
          font-size: 14px;
          color: #64748B;
        }

        .owner-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .owner {
          font-size: 16px;
          font-weight: 500;
          color: #475569;
        }

        .student {
          font-size: 14px;
          color: #64748B;
        }

        .detail-sections {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .section {
          background: white;
          padding: 20px;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(30, 90, 168, 0.08);
        }

        .section h3 {
          font-size: 18px;
          font-weight: 600;
          color: #1E5AA8;
          margin: 0 0 12px 0;
        }

        .section p {
          font-size: 15px;
          color: #475569;
          line-height: 1.6;
          margin: 0;
        }

        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 15px;
          color: #475569;
        }

        .contact-icon {
          font-size: 18px;
          width: 24px;
        }

        .pricing-info {
          display: flex;
          align-items: center;
        }

        .price {
          font-size: 20px;
          font-weight: 600;
          color: #10B981;
          background: #ECFDF5;
          padding: 8px 16px;
          border-radius: 12px;
        }

        .action-buttons {
          position: sticky;
          bottom: 0;
          background: white;
          padding: 20px;
          display: flex;
          gap: 12px;
          box-shadow: 0 -4px 16px rgba(30, 90, 168, 0.08);
        }

        .action-btn {
          flex: 1;
          padding: 16px 20px;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.2s ease;
        }

        .whatsapp-btn {
          background: #25D366;
          color: white;
        }

        .whatsapp-btn:hover {
          background: #22C55E;
          transform: translateY(-1px);
        }

        .call-btn {
          background: #1E5AA8;
          color: white;
        }

        .call-btn:hover {
          background: #1E40AF;
          transform: translateY(-1px);
        }

        @media (max-width: 768px) {
          .hero-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }

          .action-buttons {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
}

export default RealisticBusinessDirectory;